import React, { useCallback, useEffect, useRef, useState } from "react";

import { useTheme } from '@mui/material/styles';
import { useImage } from "../ImageContext/ImageContext";
import {ArrowGuide} from "../ArrowGuide/ArrowGuide";
import {on, removeListener} from "api/prokey/prokey.websocket";

//-----------------------------------------------------------------
export function Image( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const {
    settings,
    is_comp,
  } = props;
  
  const { is_full_size, is_magnifier_held } = settings || {};
  
  const theme = useTheme();

  const ref = useRef(null);

  const { width, height, image } = useImage();
  const drawn = useRef(false);

  const draw = useCallback( _draw, [image]);

  const direction = useRef('');

  //#endregion

  //#region [STYLES]

  const fit_page = {
    maxWidth  : '100%',
    maxHeight : '100%',
  }

  const fit_width = {
    width  : '100%',
    height : '',
  }

  const _styles = {
    BASE: {
      position  : 'absolute' ,
      top       : 0          ,
      left      : 0          ,
      zIndex    : 10         ,
      ...(is_full_size ? fit_width : fit_page)
    },
  }

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
    draw()
  }, [image]);

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleDirection(data) {
      //-----------------------------------------------------------------
      if( data.direction === direction.current ) {
        return;
      }
      direction.current = data.direction
    }

    const type = is_comp ? 'FILE_COMPARISON_IMAGE_DIRECTION' : 'FILE_IMAGE_DIRECTION';
    on( type, handleDirection );

    return () => {
      removeListener( type, handleDirection );
    }
  }, []);

  //#endregion

  //#region [METHOD]

  function _draw() {
    const canvas = ref.current;
    if (!canvas) {
      console.warn("[CanvasView] No canvas element yet.");
      return;
    }

    const context = canvas.getContext('2d');
    if (!context) {
      console.warn("[CanvasView] 2D context unavailable.");
      return;
    }

    // Clear logical area
    context.clearRect(0, 0, width, height);
    if( image ) context.drawImage(image, 0, 0, width, height);

    drawn.current = true;
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <canvas
          ref    = { ref }
          style  = { _styles.BASE  } 
          width  = { width  || '100%' }
          height = { height || '100%' }
        />
        {displayArrows()}
      </>
    )
  }

  //-----------------------------------------------------------------
  function displayArrows() {
    //-----------------------------------------------------------------
    if( !drawn.current || direction.current === '' ) return null;

    return (
      <ArrowGuide
        direction={direction.current}
        colors={[theme.palette.primary.main]}
        height={ref?.current?.clientHeight}
      />
    )
  }

  //#endregion

  return display();
};